App.directive('inputPassword', ['$window', 'Config', function ($window, Config) {
    return {
    	restrict: 'AEC',
        scope: {
            form: '=',
            name: '@',
            placeholder: '@',
            notBorder: '=',
            notBg: '=',
            hint: '@',
            label: '@',
            value: '@',
            disabled: '=',
            model: '=',
            required: '@',
            pattern: '@',
            addCheck: '@',
            compareField: '@'
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/input-password.html',
        link: function(scope) {
            
            scope.regex = {
                password: {
                    // value: /^(?=.*\d)(?=.*[a-z])(?=.*[\!\@\#\$\%\^\&\*\(\)\_\+\-\=])(?=.*[A-Z])(?!.*\s).{8,}$/,
                    value: /^((?=.*\d)|(?=.*[\!\@\#\$\%\^\&\*\(\)\_\+\-\=]))(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{8,}$/,
                    error: 'Hasło powinno składać się z przynajmniej 8 znaków, małej i wielkiej litery, cyfry lub znaku specjalnego jak np. (!@#$%^&*)'
                },
                password_repeat: {
                    error: 'Hasła są różne'
                }
            }

            if (scope.addCheck && scope.addCheck.length) {
                scope.checkAddValid = function() {
                    console.log(scope.addCheck, scope.model === scope.form[scope.compareField].$viewValue);
                    if (scope.addCheck === 'password_repeat') {
                        if (scope.model === scope.form[scope.compareField].$viewValue) {
                            scope.form[scope.name].$valid = true;
                        } else {
                            scope.form.$valid = false;
                            scope.form[scope.name].$valid = false;
                        }
                    }
                }
            }
        }
    };
}]);